export default __webpack_public_path__ + "static/media/MichaelLeResume.65f223f9.pdf";